import { render, staticRenderFns } from "./SaveFilterPresetMenu.vue?vue&type=template&id=1137b22e"
import script from "./SaveFilterPresetMenu.vue?vue&type=script&lang=ts"
export * from "./SaveFilterPresetMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports